var app = angular.module('directives.common');

app.factory('Cards', ['PortalApi', function (PortalApi) {
    var Cards = {
        data: [],
        isAddCard: false,
        modalType: 'add-card',
        infoTab: '',
        testCard: '2222-2222-2222-2222',
        newCard: {
            name: '',
            number: ''
        },
        getCardType: function(value){
            return value[0] === '5' && (value[1] >= 1 && value[1] <= 5) ? 'master' : (value[0] === '4' ? 'visa' : '');
        },
        addCard: function () {
            Cards.infoTab = 'addCard';
        },
        getHistory: function () {
            Cards.infoTab = 'history';
        },
        resetAddCard: function () {

            Cards.newCard = {
                name: '',
                number: ''
            };

            Cards.infoTab = '';
        },
        saveCard: function () {
            Cards.infoTab = 'preload';

            PortalApi.addCard(Cards.newCard).then(function () {
                Cards.resetAddCard();

                PortalApi.getCards().then(function (cardsList) {
                    Cards.data = cardsList;
                });

            }, function () {
                Cards.infoTab = 'addCard';
                alert('Произошла ошибка при сохранении карт.');
            });
        },
        //addCard: function () {
        //    Cards.modalType = 'add-card';
        //    Cards.newCard = {
        //        title: '',
        //        cardType: '',
        //        cardA1: {
        //            focusIn: false,
        //            value: ''
        //        },
        //        cardA2: {
        //            focusIn: false,
        //            value: ''
        //        },
        //        cardA3: {
        //            focusIn: false,
        //            value: ''
        //        },
        //        cardA4: {
        //            focusIn: false,
        //            value: ''
        //        },
        //        dateMonth: {
        //            focusIn: false,
        //            value: ''
        //        },
        //        dateYear: {
        //            focusIn: false,
        //            value: ''
        //        }
        //    };
        //
        //    Cards.isAddCard = true;
        //},
        eraseData: function(){
            Cards.newCard.title = '';
            Cards.newCard.cardA1.value = '';
            Cards.newCard.cardA2.value = '';
            Cards.newCard.cardA3.value = '';
            Cards.newCard.cardA4.value = '';
            Cards.newCard.dateMonth.value = '';
            Cards.newCard.dateYear.value = '';
        },
        //saveCard: function(form){
        //    var number = Cards.newCard.cardA1.value + '' +Cards.newCard.cardA2.value+''+Cards.newCard.cardA3.value+''+Cards.newCard.cardA4.value;
        //    var expire_date = Cards.newCard.dateMonth.value + '' + Cards.newCard.dateYear.value;
        //    var name = Cards.newCard.title;
        //
        //    if (!/^\d{16}$/.test(number) || ['4', '5', '6',].indexOf(Cards.newCard.cardA1.value[0]) === -1) {
        //        return alert('Не верный номер карты');
        //    }
        //
        //    PortalApi.saveCard({
        //        number: number,
        //        expire_date: expire_date,
        //        name: name
        //    }).then(function(data){
        //        if(data.status === "ok"){
        //            Cards.isAddCard = false;
        //            var newCard = {
        //                number: Cards.newCard.cardA1.value + ' **** **** ' + Cards.newCard.cardA4.value,
        //                name: name,
        //                cardType: Cards.getCardType(number),
        //                id: data.id
        //            };
        //
        //            Cards.data.push(newCard);
        //            Cards.eraseData();
        //        }
        //    });
        //},
        getCards: function(){
            PortalApi.getCards().then(function(data){
                var result = [];
                data.forEach(function (value, key) {
                    if (typeof(value) == "object" && parseInt(key) >= 0) {
                        value.cardType = Cards.getCardType(value.number);
                        result.push(value);
                    }
                });
                Cards.data = result;
            });
        },
        preDeleteCard: function($event, card) {

            Cards.infoTab = 'deleteCard';

            Cards.newCard = {
                name: card.name,
                number: card.number,
                id: card.id
            };

            $event.stopPropagation();
        },
        deleteCard: function(){
            Cards.infoTab = 'preload';

            PortalApi.deleteCard({
                id: Cards.newCard.id
            }).then(function(data){
                Cards.resetAddCard();

                PortalApi.getCards().then(function (cardsList) {
                    Cards.data = cardsList;
                });
            });
        },
        renameCard: function ($event, card){
            Cards.infoTab = 'rename';
             Cards.newCard = {
                name: card.name,
                number: card.number,
                id: card.id
            };

            $event.stopPropagation();
        }
    };

    return Cards;
}]);

module.exports = app;



/*****************
 ** WEBPACK FOOTER
 ** ./app/directives/common/service.js
 ** module id = 150
 ** module chunks = 1
 **/